export function setWidgetSource(token: string, source: string) {
  localStorage.setItem(`widget_source.${token}`, source);
}
